import Feature26_morph_right from './Feature26_morph_right'
export default Feature26_morph_right
